import { render } from "./PredefinedColors.vue?vue&type=template&id=d6d15cdc"
import script from "./PredefinedColors.vue?vue&type=script&lang=ts"
export * from "./PredefinedColors.vue?vue&type=script&lang=ts"
script.render = render

export default script